import React from 'react';
import '../../styles/components/AsperaSlideOverPanel.scss';
import { language } from '../../services/LanguageService';
import { Button, getIconComponent } from '../Carbon';
import { tracking } from '../../services/TrackingService';
import { AsperaOverflow } from '../AsperaOverflow';
/**
 * React Component
 *
 * The AsperaEmptyState provides the empty state design for rendering on the UI (mostly in DataTable)
 *
 * @example
 * ```javascript
 * <AsperaSlideOverPanel title={'My title'}>Content</>
 * ```
 */
export class AsperaSlideOverPanel extends React.Component {
    get panelFooter() {
        const { danger, footer, primaryButtonAction, primaryButtonText, secondaryButtonAction, secondaryButtonText, primaryButtonDisabled, primaryButtonIcon, secondaryButtonDisabled, secondaryButtonIcon } = this.props;
        const hasPrimary = !!(primaryButtonAction && primaryButtonText);
        const hasSecondary = !!(secondaryButtonAction && secondaryButtonText);
        let footerActions;
        if (hasPrimary || hasSecondary) {
            footerActions = (React.createElement("div", { className: "footer-actions" },
                hasSecondary && React.createElement(Button, { kind: "secondary", className: "footer-actions--secondary", disabled: secondaryButtonDisabled, renderIcon: secondaryButtonIcon, onClick: secondaryButtonAction }, secondaryButtonText),
                hasPrimary && React.createElement(Button, { className: "footer-actions--primary", kind: danger ? 'danger' : 'primary', disabled: primaryButtonDisabled, renderIcon: primaryButtonIcon, onClick: primaryButtonAction }, primaryButtonText)));
        }
        if (footer || footerActions) {
            return (React.createElement("div", { className: "footer-wrapper" },
                !!footer && footer,
                !!footerActions && footerActions));
        }
        return undefined;
    }
    get optionsArea() {
        const { onClose, overflowOptions, open, ignoreFormDirtyCheck } = this.props;
        const hasOnClose = typeof onClose === 'function';
        const menuOptions = {
            flipped: true,
            className: 'close-action',
            menuOptionsClass: 'close-action--dropdown',
        };
        const views = [];
        if (Array.isArray(overflowOptions) && overflowOptions.length) {
            views.push(React.createElement(AsperaOverflow, { key: "options", menuItems: overflowOptions, menuOptions: menuOptions }));
        }
        if (hasOnClose) {
            const closeSlideOver = () => {
                if (typeof onClose === 'function') {
                    if (ignoreFormDirtyCheck) {
                        onClose();
                    }
                    else {
                        tracking.checkDirtyForms(() => onClose(), true);
                    }
                }
            };
            views.push(React.createElement(Button, { key: "close", className: "close-action", tabIndex: open ? 0 : -1, hasIconOnly: true, iconDescription: language.get('modal.close'), kind: "ghost", onClick: closeSlideOver, renderIcon: getIconComponent('Close'), tooltipAlignment: "center", tooltipPosition: "left" }));
        }
        return views.length ? (React.createElement(React.Fragment, null, views.map(view => view))) : null;
    }
    get sizeToUse() {
        const { size } = this.props;
        return size || 'small';
    }
    setParentWrapper(reset) {
        const { slideInMode, open } = this.props;
        if (!slideInMode) {
            return;
        }
        const classNames = {
            small: 'max-width-slide-small',
            medium: 'max-width-slide-medium',
            large: 'max-width-slide-large',
        };
        const body = document.querySelector('body');
        if (!body)
            return;
        Object.keys(classNames).forEach(key => {
            body.classList.remove(classNames[key]);
        });
        if (slideInMode && !reset && open) {
            body.classList.add(classNames[this.sizeToUse]);
        }
    }
    componentDidMount() {
        this.setParentWrapper();
    }
    componentWillUnmount() {
        this.setParentWrapper(true);
    }
    componentDidUpdate(previousProps) {
        const { open, slideInMode, size, belowBreadcrumbs } = this.props;
        if (open !== previousProps.open ||
            slideInMode !== previousProps.slideInMode ||
            size !== previousProps.size ||
            belowBreadcrumbs !== previousProps.belowBreadcrumbs) {
            this.setParentWrapper();
        }
    }
    render() {
        const { title, subtext, automationTag, className, children, open, belowBreadcrumbs, renderLeft } = this.props;
        return (React.createElement("aside", { className: `aspera-slide-over-panel ${open ? 'open' : ''} panel-size--${this.sizeToUse} ${className ? className : ''} ${belowBreadcrumbs ? 'panel-below-breadcrumb' : ''} ${renderLeft ? 'left-render' : ''}`, "data-auto": automationTag ? automationTag : 'aspera-slide-over-panel' },
            React.createElement("div", { className: "header-with-options" },
                React.createElement("div", { className: "header-title" }, title),
                this.optionsArea),
            !!subtext && React.createElement("div", { className: "header-subtext" }, subtext),
            React.createElement("div", { className: "content" }, children),
            this.panelFooter));
    }
}
